import { StateCreator } from 'zustand';
import { UserProfile } from '../../../shared';

export interface UserProfileSlice {
  userProfile: UserProfile;
  updateProfile: (profile: UserProfile) => void;
}
export const createProfileSlice: StateCreator<UserProfileSlice, [], [], UserProfileSlice> = (set) => ({
  userProfile: undefined,
  updateProfile: (userProfile) => set(() => ({ userProfile }))
});
